/* SMT-V150-VEHICLE-FILTER */
(function () {
  'use strict';

  if (window.SMT_V150_VEHICLE_FILTER_ACTIVE) return;
  window.SMT_V150_VEHICLE_FILTER_ACTIVE = true;

  var STORAGE_KEY = 'SMT_SELECTED_VEHICLE_V1';
  var vehicleData = {
    // Türkiye odaklı öncelik: yaygın marka ve modeller önce.
    Renault: ['Clio', 'Megane', 'Taliant', 'Symbol', 'Captur', 'Austral'],
    Fiat: ['Egea', 'Doblo', 'Fiorino', 'Linea', 'Punto'],
    Ford: ['Tourneo Courier', 'Transit', 'Connect', 'Focus', 'Fiesta', 'Puma', 'Kuga'],
    Volkswagen: ['Golf', 'Polo', 'Passat', 'Caddy', 'T-Roc', 'Tiguan'],
    Toyota: ['Corolla', 'Yaris', 'Proace City', 'C-HR', 'RAV4'],
    Peugeot: ['208', 'Rifter', '2008', '308', '3008', '5008'],
    Hyundai: ['i20', 'Tucson', 'Bayon', 'Elantra', 'Accent Blue'],
    Opel: ['Corsa', 'Astra', 'Mokka', 'Crossland', 'Grandland'],
    'Citroën': ['C3', 'C4', 'Berlingo', 'C4 X', 'C5 Aircross'],
    Dacia: ['Duster', 'Sandero', 'Lodgy', 'Jogger'],
    BMW: ['3 Serisi', '1 Serisi', '5 Serisi', 'X1', 'X3'],
    'Mercedes-Benz': ['C Serisi', 'A Serisi', 'E Serisi', 'Sprinter', 'Vito', 'CLA', 'GLA'],
    Honda: ['Civic', 'City', 'HR-V', 'CR-V'],
    Nissan: ['Qashqai', 'Juke', 'X-Trail', 'Micra'],
    'Škoda': ['Octavia', 'Fabia', 'Superb', 'Scala', 'Kamiq', 'Karoq'],
    Audi: ['A3', 'A4', 'A6', 'Q2', 'Q3', 'Q5'],
    Volvo: ['XC40', 'S60', 'XC60', 'S90', 'XC90'],
    Diğer: ['Diğer model']
  };
  var vehicleTypes = ['Otomobil', 'Hafif Ticari', 'Ticari', 'Universal'];
  function readSaved() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      return saved && (saved.universal || saved.vehicleType === 'Universal' || (saved.brand && saved.model)) ? saved : null;
    } catch (error) {
      return null;
    }
  }

  function saveSaved(vehicle) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle)); } catch (error) {}
  }

  function clearSaved() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function options(select, placeholder, values) {
    select.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.appendChild(first);
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function build(marked) {
    if (document.querySelector('.smt-v150-vehicle-filter')) return true;
    var target = marked.grid.closest('.facets-vertical') || marked.grid.closest('.product-grid-container') || marked.grid;
    if (!target || !target.parentNode) return false;

    var panel = document.createElement('section');
    panel.className = 'smt-v150-vehicle-filter';
    panel.setAttribute('aria-labelledby', 'smt-v150-vehicle-filter-title');
    panel.innerHTML = [
      '<div class="smt-v150-vehicle-filter__intro">',
        '<span class="smt-v150-vehicle-filter__eyebrow">ARAÇ UYUMLULUĞU</span>',
        '<h2 id="smt-v150-vehicle-filter-title">Aracınıza göre ürünleri bulun</h2>',
        '<p>Araç tipi seçin. Universal ürünlerde marka, model ve koltuk düzeni seçimi gerekmez.</p>',
      '</div>',
      '<div class="smt-v150-vehicle-filter__fields">',
        '<label><span>Araç tipi</span><select data-smt-v150-vehicle-type autocomplete="off"><option value="">Tümü</option><option value="Otomobil">Otomobil</option><option value="Hafif Ticari">Hafif Ticari</option><option value="Ticari">Ticari</option><option value="Universal">Universal</option></select></label>',
        '<label data-smt-v150-brand-field><span>Marka</span><select data-smt-v150-brand autocomplete="off" aria-required="true" required><option value="">Marka seç</option></select></label>',
        '<label data-smt-v150-model-field><span>Model</span><select data-smt-v150-model autocomplete="off" aria-required="true" disabled required><option value="">Önce marka seç</option></select></label>',
        '<label data-smt-v150-seat-field><span>Koltuk düzeni <em>(isteğe bağlı)</em></span><select data-smt-v150-seat autocomplete="off"><option value="">Tümü</option><option value="Arka 1">Arka 1</option><option value="Arka 2+1">Arka 2+1</option><option value="Arka 3">Arka 3</option><option value="Diğer">Diğer</option></select></label>',
        '<button type="button" class="smt-v150-vehicle-filter__submit" data-smt-v150-submit disabled>Uyumlu ürünleri göster</button>',
        '<button type="button" class="smt-v150-vehicle-filter__reset" data-smt-v150-reset hidden>Seçimi temizle</button>',
      '</div>',
      '<p class="smt-v150-vehicle-filter__note" data-smt-v150-note role="status" aria-live="polite"></p>'
    ].join('');
    target.parentNode.insertBefore(panel, target);

    var brand = panel.querySelector('[data-smt-v150-brand]');
    var model = panel.querySelector('[data-smt-v150-model]');
    var vehicleType = panel.querySelector('[data-smt-v150-vehicle-type]');
    var seat = panel.querySelector('[data-smt-v150-seat]');
    var brandField = panel.querySelector('[data-smt-v150-brand-field]');
    var modelField = panel.querySelector('[data-smt-v150-model-field]');
    var seatField = panel.querySelector('[data-smt-v150-seat-field]');
    var submit = panel.querySelector('[data-smt-v150-submit]');
    var reset = panel.querySelector('[data-smt-v150-reset]');
    var note = panel.querySelector('[data-smt-v150-note]');
    var activeVehicle = null;

    function isUniversal() {
      return vehicleType.value === 'Universal';
    }

    function updateFieldVisibility() {
      var universal = isUniversal();
      [brandField, modelField, seatField].forEach(function (field) {
        field.hidden = universal;
      });
      brand.setAttribute('aria-hidden', universal ? 'true' : 'false');
      model.setAttribute('aria-hidden', universal ? 'true' : 'false');
      seat.setAttribute('aria-hidden', universal ? 'true' : 'false');
      panel.classList.toggle('is-universal', universal);
    }

    function updateSubmit() {
      submit.disabled = !isUniversal() && !(brand.value && model.value);
      panel.classList.toggle('is-ready', !submit.disabled);
    }

    function setModel(value) {
      var models = brand.value ? (vehicleData[brand.value] || ['Diğer model']) : [];
      options(model, brand.value ? 'Model seç' : 'Önce marka seç', models);
      model.disabled = !brand.value;
      if (value && models.indexOf(value) !== -1) model.value = value;
      updateSubmit();
    }

    function normalize(value) {
      return String(value || '').toLocaleLowerCase('tr-TR')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g')
        .replace(/ç/g, 'c').replace(/ö/g, 'o').replace(/ü/g, 'u')
        .replace(/[^a-z0-9]+/g, ' ').trim();
    }

    function normalizeSeat(value) {
      return String(value || '').toLocaleLowerCase('tr-TR')
        .replace(/arka|koltuk|düzen|duzen/g, '')
        .replace(/\s+/g, '').trim();
    }

    function seatMatches(value, wanted) {
      var needle = normalizeSeat(wanted);
      var haystack = normalizeSeat(value);
      return !!needle && (haystack.split(/[,;|/]+/).indexOf(needle) !== -1 || haystack.indexOf(needle) !== -1);
    }

    function vehicleTypeMatches(value, wanted) {
      return listMatches(value, wanted) || normalize(value).replace(/-/g, ' ').indexOf(normalize(wanted)) !== -1;
    }

    function listMatches(value, wanted) {
      var haystack = normalize(value);
      var needle = normalize(wanted);
      return !!needle && (haystack.split(/[\s,;|/]+/).indexOf(needle) !== -1 || haystack.indexOf(needle) !== -1);
    }

    function readFitRows(dataNode) {
      if (!dataNode) return [];
      var raw = dataNode.getAttribute('data-smt-fit-rows') || '';
      if (!raw || raw === '""' || raw === 'null') return [];
      try {
        var rows = JSON.parse(raw);
        return Array.isArray(rows) ? rows.filter(function (row) { return row && typeof row === 'object'; }) : [];
      } catch (error) {
        return [];
      }
    }

    function rowValue(row, keys) {
      for (var i = 0; i < keys.length; i += 1) {
        if (row[keys[i]] !== undefined && row[keys[i]] !== null) return row[keys[i]];
      }
      return '';
    }

    function rowIsUniversal(row) {
      return row.universal === true || normalize(rowValue(row, ['vehicleType', 'vehicle_type', 'aracTipi', 'arac_tipi', 'type'])).indexOf('universal') !== -1;
    }

    function rowMatches(row, vehicle) {
      if (rowIsUniversal(row)) return true;
      var rowBrand = rowValue(row, ['brand', 'vehicleBrand', 'marka']);
      var rowModel = rowValue(row, ['model', 'vehicleModel']);
      var rowType = rowValue(row, ['vehicleType', 'vehicle_type', 'aracTipi', 'arac_tipi', 'type']);
      var rowSeat = rowValue(row, ['seat', 'seatLayout', 'seat_layout', 'koltukDuzeni', 'koltuk_duzeni']);
      return listMatches(rowBrand, vehicle.brand) &&
        listMatches(rowModel, vehicle.model) &&
        (!vehicle.vehicleType || !rowType || vehicleTypeMatches(rowType, vehicle.vehicleType)) &&
        (!vehicle.seat || seatMatches(rowSeat, vehicle.seat));
    }

    function cardMatches(card, vehicle) {
      var dataNode = card.querySelector('[data-smt-fit-type]');
      var title = card.textContent || '';
      var universalSelection = vehicle.universal || vehicle.vehicleType === 'Universal';
      var fitRows = readFitRows(dataNode);
      if (universalSelection) {
        if (fitRows.length) return fitRows.some(rowIsUniversal);
        if (!dataNode) return normalize(title).indexOf('universal') !== -1;
        return normalize(dataNode.getAttribute('data-smt-fit-type')).indexOf('universal') !== -1 ||
          normalize(dataNode.getAttribute('data-smt-fit-tags') || '').indexOf('uyumluluk universal') !== -1 ||
          normalize(title).indexOf('universal') !== -1;
      }
      if (fitRows.length) {
        if (fitRows.some(rowIsUniversal)) return true;
        return fitRows.some(function (row) { return rowMatches(row, vehicle); });
      }
      if (!dataNode) {
        var fallback = normalize(title);
        return fallback.indexOf(normalize('universal')) !== -1 ||
          (listMatches(fallback, vehicle.brand) && listMatches(fallback, vehicle.model) && (!vehicle.vehicleType || vehicleTypeMatches(title, vehicle.vehicleType)) && (!vehicle.seat || seatMatches(title, vehicle.seat)));
      }

      var type = normalize(dataNode.getAttribute('data-smt-fit-type'));
      var brands = dataNode.getAttribute('data-smt-fit-brand') || '';
      var models = dataNode.getAttribute('data-smt-fit-model') || '';
      var productVehicleType = dataNode.getAttribute('data-smt-vehicle-type') || '';
      var seats = dataNode.getAttribute('data-smt-fit-seat') || '';
      var tags = dataNode.getAttribute('data-smt-fit-tags') || '';
      var tagText = normalize(tags);

      if (type.indexOf('universal') !== -1 || tagText.indexOf('uyumluluk universal') !== -1) return true;
      if (!type && !brands && !models && !productVehicleType && !seats && !tags) {
        var titleText = normalize(title);
        return titleText.indexOf('universal') !== -1 ||
          (listMatches(titleText, vehicle.brand) && listMatches(titleText, vehicle.model) && (!vehicle.vehicleType || vehicleTypeMatches(titleText, vehicle.vehicleType)) && (!vehicle.seat || seatMatches(title, vehicle.seat)));
      }

      if (!brands && tagText.indexOf('marka ') !== -1) brands = tags.replace(/(^|,)\s*marka:/gi, '$1');
      if (!models && tagText.indexOf('model ') !== -1) models = tags.replace(/(^|,)\s*model:/gi, '$1');
      if (!seats && (tagText.indexOf('koltuk ') !== -1 || tagText.indexOf('koltuk duzeni ') !== -1)) {
        seats = tags.replace(/(^|,)\s*(koltuk_duzeni|koltuk):/gi, '$1');
      }
      if (!productVehicleType && tagText.indexOf('arac tipi ') !== -1) {
        productVehicleType = tags.replace(/(^|,)\s*arac_tipi:/gi, '$1');
      }
      return listMatches(brands, vehicle.brand) && listMatches(models, vehicle.model) && (!vehicle.vehicleType || vehicleTypeMatches(productVehicleType, vehicle.vehicleType)) && (!vehicle.seat || seatMatches(seats, vehicle.seat));
    }

    function filterCards(vehicle) {
      var cards = Array.prototype.slice.call(document.querySelectorAll('#product-grid > li'));
      var visible = 0;
      cards.forEach(function (card) {
        var visibleCard = !vehicle || cardMatches(card, vehicle);
        card.hidden = !visibleCard;
        if (visibleCard) visible += 1;
      });
      if (!vehicle) {
        note.textContent = '';
      } else if (vehicle.universal || vehicle.vehicleType === 'Universal') {
        note.textContent = 'Universal ürünler gösteriliyor.';
      } else {
        note.textContent = vehicle.brand + ' ' + vehicle.model + (vehicle.vehicleType ? ' • ' + vehicle.vehicleType : '') + (vehicle.seat ? ' • ' + vehicle.seat : '') + ' için ' + visible + ' ürün gösteriliyor. Universal ürünler dahildir.';
      }
    }

    function apply(vehicle) {
      activeVehicle = vehicle;
      saveSaved(vehicle);
      reset.hidden = false;
      filterCards(vehicle);
    }

    options(brand, 'Marka seç', Object.keys(vehicleData));
    brand.addEventListener('change', function () { setModel(); model.focus(); });
    model.addEventListener('change', updateSubmit);
    vehicleType.addEventListener('change', function () {
      if (isUniversal()) {
        brand.value = '';
        seat.value = '';
        setModel();
        updateFieldVisibility();
        updateSubmit();
        filterCards({ universal: true, vehicleType: 'Universal', brand: '', model: '', seat: '' });
      } else {
        if (activeVehicle && activeVehicle.universal) {
          activeVehicle = null;
          clearSaved();
          reset.hidden = true;
          filterCards(null);
        }
        updateFieldVisibility();
        updateSubmit();
        if (brand.value && model.value) filterCards({ brand: brand.value, model: model.value, vehicleType: vehicleType.value, seat: seat.value });
      }
    });
    seat.addEventListener('change', function () {
      if (brand.value && model.value) filterCards({ brand: brand.value, model: model.value, vehicleType: vehicleType.value, seat: seat.value });
    });
    submit.addEventListener('click', function () {
      if (!submit.disabled) {
        apply(isUniversal() ? { universal: true, vehicleType: 'Universal', brand: '', model: '', seat: '' } : { brand: brand.value, model: model.value, vehicleType: vehicleType.value, seat: seat.value });
      }
    });
    reset.addEventListener('click', function () {
      activeVehicle = null;
      clearSaved();
      brand.value = '';
      setModel();
      vehicleType.value = '';
      seat.value = '';
      updateFieldVisibility();
      reset.hidden = true;
      filterCards(null);
      note.textContent = 'Araç seçimi temizlendi.';
    });

    var saved = readSaved();
    if (saved && (saved.universal || saved.vehicleType === 'Universal')) {
      activeVehicle = { universal: true, vehicleType: 'Universal', brand: '', model: '', seat: '' };
      vehicleType.value = 'Universal';
      brand.value = '';
      seat.value = '';
      setModel();
      updateFieldVisibility();
      updateSubmit();
      reset.hidden = false;
      filterCards(activeVehicle);
    } else if (saved && vehicleData[saved.brand]) {
      activeVehicle = saved;
      brand.value = saved.brand;
      setModel(saved.model);
      if (saved.vehicleType && vehicleTypes.indexOf(saved.vehicleType) !== -1) vehicleType.value = saved.vehicleType;
      if (saved.seat) seat.value = saved.seat;
      updateFieldVisibility();
      updateSubmit();
      reset.hidden = false;
      filterCards(saved);
    } else {
      updateFieldVisibility();
      setModel();
    }

    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && typeof MutationObserver === 'function') {
      var refreshFrame = 0;
      var gridObserver = new MutationObserver(function () {
        if (!activeVehicle || refreshFrame) return;
        refreshFrame = window.requestAnimationFrame(function () {
          refreshFrame = 0;
          filterCards(activeVehicle);
        });
      });
      gridObserver.observe(gridContainer, { childList: true, subtree: true });
    }
    return true;
  }

  function initialize() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var productGrid = grid.querySelector('#product-grid');
    if (!productGrid) return;
    document.documentElement.classList.add('smt-vehicle-filter-page');
    build({ grid: productGrid });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
